import { LessonLike } from '@/helpers/types/LessonLike';

export const allInLessonContainersSelected = <T extends { lessons: LessonType[] }, LessonType extends LessonLike>(
    lessonContainers: T[],
    selected: LessonType[]
): boolean => {
    const isSelected = (lesson: LessonType): boolean => {
        if (!selected.some((s) => s.id === lesson.id)) {
            return false;
        }
        if (lesson.sub_lessons) {
            return (lesson.sub_lessons as LessonType[]).every(isSelected);
        }
        return true;
    };

    return lessonContainers.every((container) => container.lessons.every(isSelected));
};
